import { globalModal, type ModalOpenProps } from '@i22team/td-longtail-vue-components';

export const openModal = (props: ModalOpenProps) => {
  globalModal.openModal(props);
};

export const onCloseModal = () => {
  globalModal.onCloseModal();
};

export const closeModal = () => {
  globalModal.closeModal();
};
